
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class RestService {
  constructor(private http: HttpClient) {}

  sendContactForm(data: any) {
    return this.http.post('/api/contact', {data});
  }

  validateToken(data:any){
    return this.http.post('/api/validateToken', {data});
  }
}